import {Translate} from "../Translate";
import {defaultVariabls} from "../index";

const topMenuRoutesConfig = [
  {
    id: 'homePage',
    title: Translate.homePage,
    type: 'item',
    url: `${defaultVariabls.website}`,
  },
    {
        id: 'contact',
        title: Translate.contactPage,
        type: 'item',
        url: `${defaultVariabls.website}/contact`,
    },
    {
        id: 'about',
        title: Translate.aboutPage,
        type: 'item',
        url: `${defaultVariabls.website}/about`,
    },
];
export default topMenuRoutesConfig;
